import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AdminMembershipReviewService, MembershipReview, MembershipDecision } from 'app/services/admin-membership-review.service';
import { BaseTextAreaComponent } from "app/components/ui-kit/inputs/base-text-area/base-text-area.component";
import { SpinnerComponent } from "app/components/ui-kit/loaders/spinner/spinner.component";

@Component({
  selector: 'app-admin-review-memberships',
  standalone: true,
  imports: [CommonModule, FormsModule, BaseTextAreaComponent, SpinnerComponent],
  templateUrl: './admin-review-memberships.component.html',
  styleUrls: ['./admin-review-memberships.component.scss'],
})
export class AdminReviewMembershipsComponent implements OnInit {
  search: string = '';
  activeTab: 'pending' | 'decisions' = 'pending';

  pending: MembershipReview[] = [];
  filtered: MembershipReview[] = [];
  decisions: MembershipDecision[] = [];

  selected?: MembershipReview;
  declineReason: string = '';
  isProcessingDecision: boolean;

  constructor(private reviewService: AdminMembershipReviewService) { }

  ngOnInit() {
    this.reviewService.getPendingReviews().subscribe((reviews) => {
      this.pending = reviews;
      console.log(this.pending)
      this.applyFilter();
    });
    this.reviewService.getDecisions().subscribe((decisions) => {
      this.decisions = decisions;
    });
  }

  applyFilter() {
    const q = this.search.toLowerCase();
    this.filtered = this.pending.filter((r) => r.email.toLowerCase().includes(q));
  }

  select(review: MembershipReview) {
    this.selected = review;
    this.declineReason = 'Your document was accepted for initial access, but it did not contain enough information to complete membership verification. Please submit a clearer itinerary or membership document. This next submission must be fully approved before you can continue.';
  }

  approve() {
    if (!this.selected) return;
    this.isProcessingDecision = true;
    this.reviewService.approveMembership(this.selected.id).subscribe(() => {
      this.selected = undefined;
      this.isProcessingDecision = false;
    });
  }

  requireHardReview() {
    if (!this.selected) return;
    this.isProcessingDecision = true;
    this.reviewService
      .requireHardVerification(this.selected.id, this.declineReason)
      .subscribe(() => {
        this.selected = undefined;
        this.declineReason = '';
        this.isProcessingDecision = false;
      });
  }

  decline() {
    if (!this.selected) return;
    this.isProcessingDecision = true;
    this.reviewService
      .declineMembership(this.selected.id, this.declineReason)
      .subscribe(() => {
        this.selected = undefined;
        this.declineReason = '';
        this.isProcessingDecision = false;
      });
  }

  closeModal() {
    this.selected = undefined;
  }
}
